import React, { useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainerCustom from "../../components/Common/TableContainerCustom";
import { Card, CardBody, Col, Container, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { useTypePropertyCols } from "./TypePropertyListMemo";
import { withTranslation } from "react-i18next";
import { modalTypePropertyShow } from "../../store/actions";

import { getTypeProperties } from "store/CatTypeProperties/actions";
import FormTypeProperty from "./FormTypeProperty";

const CatTypePropertyList = (props) => {
    const dispatch = useDispatch();

    const [isEdit, setIsEdit] = useState(false);
    const [typePropertyL, setTypePropertyL] = useState(null);

    const handleSetEditTypeProperty = (typeProperty) => {
        setTypePropertyL(typeProperty)
        setIsEdit(true)
        toggleModalAddTypeProperty()
    }

    const memoTypePropertiesCols = useTypePropertyCols(typePropertyL, handleSetEditTypeProperty);

    const { typeProperties, typePropertyModalShow, totalItems } = useSelector(state => ({
        typeProperties: state.TypePropertyReducer.typeProperties,
        typePropertyModalShow: state.TypePropertyReducer.typePropertyModalShow,
        totalItems: state.TypePropertyReducer.totalItems
    }));

    /**
     * @param {*} pagination
     *
     */
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
        search: {
            filter: {}
        }
    });

    const handlePageChange = (newPage, search) => {
        console.log(search)
        setPagination(prev => ({
            ...prev,
            page: newPage,
            search: search || prev.search
        }));
    };

    const toggleModalAddTypeProperty = () => {
        let typePropertyModalShowL = !typePropertyModalShow;
        dispatch(modalTypePropertyShow(typePropertyModalShowL));
    };

    const handleGetTypeProperties = () => {
        dispatch(getTypeProperties({for_: 'inventory'}));
    };

    useEffect(() => {
        handleGetTypeProperties();
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={props.t("Areas")}
                        breadcrumbItem={props.t("Listado")}
                    />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <TableContainerCustom
                                        className="" addBtnNewFlag={true} 
                                        lblBtnAddNew = "Nueva Tipo de Bien" 
                                        handleAddNewClick={toggleModalAddTypeProperty}
                                        data={typeProperties}
                                        isGlobalFilter={false}
                                        isAddOptions={false} serverSidePagination={{
                                            totalItems: totalItems,
                                            currentPage: pagination.page,
                                            onPageChange: handlePageChange,
                                            search: pagination.search
                                        }} customPageSize={pagination.pageSize}
                                        columns={memoTypePropertiesCols} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Modal size={"md"} isOpen={typePropertyModalShow} backdrop={'static'} toggle={toggleModalAddTypeProperty}>
                        <ModalHeader toggle={toggleModalAddTypeProperty} tag="h4">
                            Nuevo Tipo de Propiedad
                        </ModalHeader>
                        <ModalBody>
                            <Row>           
                                <FormTypeProperty isEdit={isEdit} typeProperty={typePropertyL} />
                            </Row>
                        </ModalBody>
                    </Modal>
                </Container>
            </div>
        </React.Fragment>
    )

}
export default withTranslation()(CatTypePropertyList);;